import type { ReactNode } from 'react';
import { PermissionContext, type PermissionResolver } from './permissionContext';

export interface PermissionProviderProps {
    /**
     * Answers one permission question. FS-6 supplies the real `(role, resource, level)` driver;
     * a test supplies a fixture; omitted, everything is allowed.
     */
    readonly resolve: PermissionResolver;
    readonly children: ReactNode;
}

/**
 * Publishes a permission resolver to everything below it.
 *
 * Thin on purpose — the seam is the `PermissionResolver` type, not this component, and keeping the
 * provider free of caching or memoisation leaves FS-6 free to decide how decisions are fetched
 * without unpicking anything here. A resolver that is expensive to call should memoise itself,
 * where it knows what invalidates.
 */
export function PermissionProvider({ resolve, children }: PermissionProviderProps) {
    return <PermissionContext.Provider value={resolve}>{children}</PermissionContext.Provider>;
}
